// extracted by mini-css-extract-plugin
export var container = "Skills-module--container--2AipD";
export var title = "Skills-module--title--2HWX7";
export var skillsContainer = "Skills-module--skillsContainer--R62Vt";